import React, { useState, useEffect } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ListDialog } from "../shared/listDialog";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { utils } from "../../services/helpers/utils";
import { alertService } from '../../services/helpers/alert.service';

export const MMRecordInvestigations = (props) => {

    const _newRow = {
        idInvestigatie: "",
        dataEfectuarii: null,
        statusFinanciar: props.financiar ?? 0,
        statusFacturare: 0,
        suplimentar: 1
    };

    const rol = sessionStorage.getItem("rol");

    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([]);
    const [dropdown, setDropdown] = useState([]);
    const [newRow, setNewRow] = useState(_newRow);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getOptionalInvestigations({ recordId: props.idFisa })
                .then(response => {
                    if (response) {
                        setList(response);
                        props.setInvestigatii(response);
                    }
                });
        }
    }, [props.refresh]);

    useEffect(() => {
        if (props.dataDeschidere) {
            mmRecordService.getInvestigationsWithPrice({ location: props.idLocatie ?? 0, date: props.dataDeschidere, recordId: props.idFisa ?? 0 })
                .then(response => {
                    if (response) {
                        setDropdown(response);
                    }
                });
        }
    }, [props.idLocatie, props.dataDeschidere]);

    useEffect(() => {
        if (list.length > 0 && dropdown.length > 0) {
            var d = [];
            for (var item in list) {
                var el = utils.findObjectById(dropdown, list[item].idInvestigatie)

                if (el) {
                    d.push(el);
                }

            }
            setDefaults(d);
        }

    }, [list, dropdown]);

    useEffect(() => {

        let newList = [...list];
        for (let i = 0; i < newList.length; i++) {
            newList[i].statusFinanciar = props.financiar;
        }
        updateLists(newList);
    }, [props.financiar]);



    const updateLists = (list) => {

        setList(list);
        props.setInvestigatii(list);
        if (props.isModified) {
            setIsModified(true);
        }
    }

    const handleAdd = () => {
        if (props && !props.idLocatie) {
            alertService.error("Nu ati selectat locatia!");
            return;
        }
        let newList = [...list]
        newList.push(_newRow);
        updateLists(newList);
        setNewRow(_newRow);
    };

    const handleChange = (event, index, field) => {
        const updatedList = [...list];
        var v = event.target.value;
        if (v && v.hasOwnProperty("id")) {
            updatedList[index][field] = v.id;
            setSearchTerm("");
        }
        else {
            updatedList[index][field] = v;
        }
        updateLists(updatedList);
    };

    const handleDelete = (index) => {
        alertService.confirm("Atentie", "Esti sigur ca vrei sa stergi aceasta investigatie?"
            , () => {
                const updatedList = [...list];
                updatedList.splice(index, 1);
                updateLists(updatedList);
            }
            , () => { return; }
        );
    };

    const [showDialog, setShowDialog] = useState(false);
    const [clickedIndex, setClickedIndex] = useState(null);

    const handleDialog = () => {
        setShowDialog(!showDialog);
    }

    const handleClick = (item) => {
        setClickedIndex(item);
        setShowDialog(true);
    }

    const handleReturn = (item) => {

        let newList = [...list];
        newList[clickedIndex].idInvestigatie = dropdown[item].id;
        updateLists(newList);
             
    }

    const handleFilterChange = (e) => {
        setSearchTerm(e.filter.value);
    };

    const filtred = searchTerm
        ? dropdown.filter((item) =>
            item.text.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : dropdown;



    return (
        <>
            <fieldset>
                <legend className="pt20 pb5">Investigatii suplimentare</legend>
                <table className="tbl tbladd mt5" name="lista_investigatii_recomandate" width="100%">
                    <thead>
                        <tr>
                            <th width="490">Nume investigatie</th>
                            <th width="140">Data efectuarii</th>
                            <th>Status financiar</th>
                            <th>Status facturare</th>
                            <th>Motiv respingere</th>
                            {props.finalizare != 1 && rol!=2 &&<th width="50">Editeaza</th>}
                            {props.finalizare != 1 && rol!=2 &&<th width="50">Sterge</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((item, index) => (
                            <tr key={index}>
                                <td name="investigatie">
                                    <DropDownList name="idInvestigatie"
                                        className=" w400"
                                        data={filtred}
                                        textField="text"
                                        dataItemKey="id"
                                        value={defaults[index]}
                                        onChange={(event) =>
                                            handleChange(event, index, "idInvestigatie")
                                        }
                                        disabled={props.finalizare == 1 || rol == 2}
                                        filterable
                                        onFilterChange={handleFilterChange}
                                    />
                                </td>
                                <td>
                                    <DatePicker name="dataEfectuarii"
                                        value={item.dataEfectuarii ? utils.convert2DatePickerDate(item.dataEfectuarii) : null}
                                        max={new Date()}
                                        onChange={(event) => handleChange(event, index, "dataEfectuarii")}
                                        className="text"
                                        disabled={props.finalizare == 1 || rol == 2}
                                    />
                                </td>
                                <td name="status_financiar"> {item.statusFinanciar} </td>
                                <td name="status_facturare"> {item.statusFacturare} </td>
                                <td name="motiv_respingere"> {item.motivRespingere ?? ""}</td>
                                {props.finalizare != 1 && rol != 2 &&
                                    <td name="investigatie_edit" onClick={() => handleClick(index)}>
                                        <span className="icon modifica center"></span>
                                    </td>
                                }
                                {props.finalizare != 1 && rol !=2 &&
                                    <td name="investigatie_del" onClick={() => handleDelete(index)}>
                                        <span className="icon sterge center"></span>
                                    </td>
                                }
                            </tr>
                        ))}
                    </tbody>
                </table>

                {!props.finalizare && rol!=2 && (
                    <button name="adauga_investigatie" className="btn mt10"
                        onClick={handleAdd}
                    >Adauga investigatie</button>
                )}

            </fieldset>

            {
                showDialog && <ListDialog title="Investigatii"
                    data={dropdown}
                    handleDialog={handleDialog}
                    handleReturn={handleReturn} />
            }
        </>
    );
}